

















import Vue from 'vue'
import { Component, VModel } from 'vue-property-decorator'

import { DistributionState } from '../../DistributionEditor/types'

@Component
export default class DistributionsFilters extends Vue {
  @VModel() activeStateFilter!: DistributionState | null

  distributionOptions = [
    { label: this.$t(`field_distribution_${ DistributionState.Wait }_title`).toString(), value: DistributionState.Wait },
    { label: this.$t(`field_distribution_${ DistributionState.Start }_title`).toString(), value: DistributionState.Start },
    { label: this.$t(`field_distribution_${ DistributionState.Success }_title`).toString(), value: DistributionState.Success },
    { label: this.$t(`field_distribution_${ DistributionState.Cancel }_title`).toString(), value: DistributionState.Cancel },
    { label: this.$t(`field_distribution_${ DistributionState.Error }_title`).toString(), value: DistributionState.Error },
  ]

  handleChange(newState:DistributionState) {
    if (this.activeStateFilter === newState) {
      this.activeStateFilter = null
    } else {
      this.activeStateFilter = newState
    }
  }
}
